import React, { Component } from "react";
import { getDecodedHtml } from "utils/getDecodedHtml";

class MaterialBoxFooter extends Component {
	render() {
		const { data } = this.props;
		const { instruction, footerLabel, footerLink, footerLinkTarget, dataACat, dataAAct, dataALbl } =
			data.footer;
		return (
			<div className="material-box-footer">
				<h5
					className="h5-italic-left-almost-black material-box-footer-cell"
					dangerouslySetInnerHTML={{ __html: getDecodedHtml(instruction) }}
				></h5>
				{instruction ? <div>&nbsp;&nbsp;</div> : ""}
				<div className="material-box-footer-cell material-box-footer-link">
					<a
						href={footerLink}
						className="material-box-footer"
						label={footerLabel}
						dangerouslySetInnerHTML={{ __html: getDecodedHtml(footerLabel) }}
						target={footerLinkTarget}
						data-a-cat={dataACat}
						data-a-act={dataAAct}
						data-a-lbl={dataALbl}
					></a>
				</div>
			</div>
		);
	}
}

export default MaterialBoxFooter;
